<template>
    <div class="layout" :style="{ height: minHeight }">
        <Header
            v-if="$route.name !== 'cq-index'"
            :isBack="!!$route.query.mode"
            :backName="
                $route.name === 'moreAppointment' ? '返回上一页' : '返回首页'
            "
            :jump="$route.name !== 'moreAppointment' ? 'fc-screen' : 'ns-index'"
            :title="title"
        />
        <Tags
            v-if="
                $route.name !== 'fc-main' &&
                    $route.name !== 'moreAppointment' &&
                    $route.name !== 'cq-index'
            "
            :active="$route.name"
            @handleTitle="handleTitle"
        />
        <router-view class="body"></router-view>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Tags from './components/Tags'

export default {
    components: {
        Header,
        Tags
    },
    data() {
        return {
            title: '丰城市农事服务大数据平台',
            minHeight: '',
            timerDate: null,
            time: ['', '', '']
        }
    },
    methods: {
        handleTitle(title) {
            this.title = title
        }
    },
    beforeMount() {
        const clientWidth = document.documentElement.clientWidth
        this.minHeight = `${(1080 / 1920) * clientWidth}px`
    },
    mounted() {
        document.title = this.title
    }
}
</script>
<style lang="scss" scoped>
.layout {
    display: flex;
    flex-direction: column;
    background-size: 1920px 1080px;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../../assets/images/large-screen-bg.jpg');
    background-color: #04090f; // for ie10
    position: relative;
    > .body {
        padding: 21px 15px 11px 15px;
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        box-sizing: border-box;
    }
}
</style>
